import * as RequestState from 'forms-utils-lib/RequestState';
import * as Actions from './actions';
const INIT_STATE = {
  settings: {},
  lastFetched: null,
  requestState: RequestState.NOT_REQUESTED
};
const settings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case Actions.REQUEST_SETTINGS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_SETTINGS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_SETTINGS:
      return Object.assign({}, state, {
        settings: action.settings,
        lastFetched: action.meta.timestamp
      });
    case Actions.FAIL_GETTING_SETTINGS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
};
export default settings;